import * as React from 'react';
import { btnStyle } from '../forms/styles/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { SerializedStyles } from '@emotion/core';
import Msg from '../localization/Msg';
import { Map } from '../language/models';


type CaptionProps = {
  str: string | number;
  defaultMsg?: string | number;
  replace?: Map<string | number | undefined>;
  captionStyle?: SerializedStyles;
}


interface Props extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  icon: IconProp;
  iconStyle: SerializedStyles;
  iconSize?: SizeProp;
  caption?: CaptionProps;
}


/**
 * ActionIcon: a component that renders an icon which behaves as a button.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ActionIcon: React.FC<Props> = props => {
  const { icon, iconStyle, iconSize, caption, ...rest } = props;

  return (
    <button {...rest} css={btnStyle.invisible}>
      <FontAwesomeIcon icon={icon} css={iconStyle} size={iconSize || '1x'} />
      {
        !!caption && (
          <Msg str={caption.str} defaultMsg={caption.defaultMsg} replace={caption.replace} css={caption.captionStyle} />
        )
      }
    </button>
  );
};

export default ActionIcon;
